import {
	API_ADMIN_GET_ALL_SCANNERS,
	API_ADMIN_GET_SCANNER,
	API_ADMIN_PATCH_SCANNER,
	API_ADMIN_POST_SCANNER,
	API_ADMIN_DELETE_SCANNER,
	ADMIN_INIT_NEW_SCANNER,
	ADMIN_RESET_FOCUS_SCANNER,
} from 'actions/scanner';

export function adminGetAllScanners() {
	return {
		type: API_ADMIN_GET_ALL_SCANNERS,
		payload: {
			request: {
				url: `/scanners`,
			},
		},
	};
}

export function adminGetScannerById(scannerId) {
	return {
		type: API_ADMIN_GET_SCANNER,
		payload: {
			request: {
				url: `/admin/scanners/${scannerId}`,
			},
		},
	};
}

export function adminPatchScanner(scanner) {
	return {
		type: API_ADMIN_PATCH_SCANNER,
		payload: {
			request: {
				url: `/admin/scanners/${scanner.id}`,
				method: 'PATCH',
				data: scanner,
			},
		},
	};
}

export function adminPostScanner(scanner) {
	return {
		type: API_ADMIN_POST_SCANNER,
		payload: {
			request: {
				url: `/admin/scanners`,
				method: 'POST',
				data: scanner,
			},
		},
	};
}

export function adminDeleteScanner(scannerId) {
	return {
		type: API_ADMIN_DELETE_SCANNER,
		payload: {
			request: {
				url: `/admin/scanners/${scannerId}`,
				method: 'delete',
			},
		},
	};
}


export function initNewScanner() { 
	return {
		type: ADMIN_INIT_NEW_SCANNER,
	};
}

export function resetFocusScanner() {
	return {
		type: ADMIN_RESET_FOCUS_SCANNER,
	};
}
